import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'
import { AuthProvider } from './contexts/AuthContext.tsx'
import { firebaseEnv } from './firebase'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: firebaseEnv,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
)
